import { combineReducers } from 'redux';

import signInReducer from './signin-reducer';
import chatReducer from './chat-reducer';
import analyticsDashboardReducer from './analytics-dashboard-reducer';
import personSearchReducer from './person-search-reducer';
// import chapterProgressReducer from './chapterProgress-reducer';

export default combineReducers({
  signInReducer,
  chatReducer,
  analyticsDashboardReducer,
  personSearchReducer
});
